{
    "ALERTING": {
        "DELAY": "Verzögerung",
        "CHECKBOX_HELP": "Du erhälst bei Eintritt des Ereignisses mit der ausgewählten Verzögerung eine E-Mail.",
        "FAULT": "Fehler",
        "ONLINE_STATUS": "Online-Status",
        "OTHER_USERS": "Weitere Benutzer"
    }
}
